import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import sideImg from "../../assets/evacassets/image/sideImg.png";
import factoryImg from "../../assets/evacassets/image/factory.png";
import CIcon from "@coreui/icons-react";
import {
  cilChatBubble,
  cilEnvelopeClosed,
  cilLocationPin,
  cilPhone,
} from "@coreui/icons";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

import { CButton, CCol, CContainer, CRow } from "@coreui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
// import NavbarLogo from "../../assets/evacassets/image/NavbarLogo.png";
import NavbarLogo from "../../assets/evacassets/image/logo.png";
import NewNavbar from "../../Components/newNavbar/NewNavbar";
import OutSideNavBar from "../outsideNavBar/OutSideNavBar";
import Footer from "../../Components/footer/Footer";
// Custom icons for charging stations and factories
const chargingIcon = new L.Icon({
  iconUrl: sideImg,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const factoryIcon = new L.Icon({
  iconUrl: factoryImg,
  iconSize: [25, 25],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const locations = [
  {
    type: "charging",
    name: "Main Charging Station",
    position: [30.841383, 76.953263],
    address: "123 Electric Ave, ElectriCity",
  },
  {
    type: "factory",
    name: "Factory 1",
    position: [30.669378, 76.84715],
    address: "456 Power Plant Rd, Energetown",
  },
  {
    type: "factory",
    name: "Factory 2",
    position: [30.700381, 76.804671],
    address: "789 Dynamo St, Voltville",
  },
  {
    type: "factory",
    name: "Factory 3",
    position: [30.848193, 76.954302],
    address: "789 Dynamo St, Voltville",
  },
];

// const SupportPage = ({ scrollToSection }) => {
const SupportPage = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [ignoreNextClick, setIgnoreNextClick] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [chatOpen, ignoreNextClick]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (inputMessage.trim() !== "") {
      setMessages([...messages, { text: inputMessage, sender: "user" }]);
      setInputMessage("");
      // Simulate a response
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            text: "Thank you for your message. Our support team will get back to you soon.",
            sender: "support",
          },
        ]);
      }, 1000);
    }
  };

  const openChat = () => {
    setChatOpen(true);
    setIgnoreNextClick(true);
    setTimeout(() => setIgnoreNextClick(false), 100);
  };

  const handleOutsideClick = (e) => {
    if (!ignoreNextClick && chatOpen && !e.target.closest("#chat-container")) {
      setChatOpen(false);
    }
  };

  const nav = useNavigate();
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen w-full  overflow-auto">
      <OutSideNavBar />

      <div className="flex flex-col md:flex-row items-stretch gap-6 my-5 custom-container overflow-auto">
        <div className="flex flex-col gap-6 w-full md:w-2/5 ">
          <div className="border rounded-xl p-6 bg-white ">
            <div className="flex items-center gap-2 mb-2">
              <h4>
                <FaPhoneAlt size={15} />
              </h4>
              <h4 className="text-lg font-semibold">Call us</h4>
            </div>
            <p className="text-gray-600 ">Call our team</p>
            <a
              href="tel:+919876543210"
              className="text-blue-600 font-medium hover:underline mt-2 block"
            >
              +91 9876543210
            </a>
          </div>

          <div className="border  rounded-xl p-6 bg-white ">
            <div className="flex items-center gap-2 mb-2">
              <h4>
                <FaPhoneAlt size={15} />
              </h4>
              <h4 className="text-lg font-semibold">Technical Support</h4>
            </div>
            <p className="text-gray-600">
              Call our team Monday-Saturday from 9am to 5pm.
            </p>
            <a
              href="tel:+919876543210"
              className="text-blue-600 font-medium hover:underline mt-2 block"
            >
              +91 9876543210
            </a>
          </div>

          <div className="border  rounded-xl p-6 bg-white ">
            <div className="flex items-center gap-2 mb-2">
              <h4>
                <MdEmail size={20} />
              </h4>
              <h4 className="text-lg font-semibold">Email support</h4>
            </div>
            <p className="text-gray-600">
              Email our team Monday-Saturday from 9am to 5pm.
            </p>
            <a
              href="mailto:pyramid_pwn@pyramidelectronics.in"
              className="text-blue-600 font-medium hover:underline mt-2 block"
            >
              pyramid_pwn@pyramidelectronics.in
            </a>
          </div>
        </div>

        <div className="hidden md:block w-px bg-gray-300"></div>

        <div className="flex flex-col gap-6 w-full md:w-2/3">
          <div className="border rounded-xl p-6 bg-white  ">
            <div className="flex items-center gap-2 mb-2">
              <h4>
                <FaLocationDot size={20} />
              </h4>
              <h4 className="text-lg font-semibold">
                Registered Office Address:
              </h4>
            </div>
            <p className="text-gray-600">
              Pyramid Electronics Plot No. 1, Sector 1, <br />
              Parwanoo, Solan, Himachal Pradesh 173220, India
            </p>
          </div>

          <div className="h-64 md:h-96 border rounded-xl overflow-hidden">
            <MapContainer
              center={[30.775, 76.800012]}
              zoom={isMobile ? 9 : 10}
              className="rounded-xl h-full w-full"
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {locations.map((location, index) => (
                <Marker
                  key={index}
                  position={location.position}
                  icon={
                    location.type === "charging" ? chargingIcon : factoryIcon
                  }
                >
                  <Popup>
                    <strong>{location.name}</strong>
                    <br />
                    {location.address}
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </div>
        {/* <button onClick={openChat} style={styles.chatButton(isMobile)}>
          <CIcon icon={cilChatBubble} style={styles.chatIcon} />
          Open Chat Support
        </button> */}
        {chatOpen && (
          <div id="chat-container" style={styles.chatContainer(isMobile)}>
            <div style={styles.chatMessages}>
              {messages.map((msg, index) => (
                <div
                  key={index}
                  style={
                    msg.sender === "user"
                      ? styles.userMessage
                      : styles.supportMessage
                  }
                >
                  {msg.text}
                </div>
              ))}
            </div>
            <form
              onSubmit={handleSendMessage}
              style={styles.chatInputContainer}
            >
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder="Type your message here..."
                style={styles.chatInput}
              />
              <button type="submit" style={styles.sendButton}>
                Send
              </button>
            </form>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: (isMobile) => ({
    flex: 1,
    backgroundColor: "red",
    color: "black",
    padding: isMobile ? "1rem" : "3rem",
  }),
  contactHeader: (isMobile) => ({
    textAlign: "center",
    marginBottom: "2rem",
    fontSize: isMobile ? "2rem" : "2.5rem",
    color: "#333",
    textTransform: "uppercase",
    letterSpacing: "2px",
  }),
  contactContent: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  }),
  mapContainer: (isMobile) => ({
    width: "100%",
    height: isMobile ? "300px" : "400px",
    marginBottom: "2rem",
    borderRadius: "15px",
    overflow: "hidden",
    // box : "0 5px 15px rgba(0, 0, 0, 0.1)",
    zIndex: 1,
  }),
  contactDetails: (isMobile) => ({
    width: isMobile ? "100%" : "35%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "#f0edfc",
    padding: "2rem",
    borderRadius: "15px",
  }),
  map: {
    height: "100%",
    width: "100%",
  },
  subHeader: (isMobile) => ({
    fontSize: isMobile ? "1.5rem" : "1.8rem",
    marginBottom: "1rem",
    color: "#333",
    borderBottom: "2px solid #5856d6",
    paddingBottom: "0.5rem",
  }),
  contactInfo: (isMobile) => ({
    fontSize: isMobile ? "1rem" : "1.2rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
  }),
  icon: {
    marginRight: "1rem",
    color: "#007aff",
  },
  chatButton: (isMobile) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#007aff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "25px",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "1rem",
    transition: "background-color 0.3s",
    position: "fixed",
    bottom: "20px",
    right: "20px",
    box: "0 2px 10px rgba(0,0,0,0.2)",
  }),
  chatIcon: {
    marginRight: "10px",
  },
  chatContainer: (isMobile) => ({
    position: "fixed",
    bottom: isMobile ? "60px" : "20px",
    right: isMobile ? "10px" : "20px",
    width: isMobile ? "calc(100% - 20px)" : "300px",
    height: isMobile ? "40vh" : "400px",
    backgroundColor: "white",
    borderRadius: isMobile ? "20px" : "10px",
    box: isMobile ? "0 0 10px rgba(0,0,0,0.1)" : "0 0 10px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    zIndex: 999,
    overflowY: "auto",
  }),
  chatMessages: {
    flex: 1,
    overflowY: "auto",
    padding: "10px",
  },
  userMessage: {
    backgroundColor: "#5856d6",
    color: "white",
    alignSelf: "flex-end",
    borderRadius: "15px 15px 0 15px",
    padding: "10px",
    margin: "5px",
    maxWidth: "80%",
  },
  supportMessage: {
    backgroundColor: "#f0f0f0",
    color: "black",
    alignSelf: "flex-start",
    borderRadius: "15px 15px 15px 0",
    padding: "10px",
    margin: "5px",
    maxWidth: "80%",
  },
  chatInputContainer: {
    display: "flex",
    padding: "10px",
  },
  chatInput: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "20px",
    marginRight: "10px",
  },
  sendButton: {
    backgroundColor: "#5856d6",
    color: "white",
    border: "none",
    borderRadius: "20px",
    padding: "10px 20px",
    cursor: "pointer",
  },
  contactLink: {
    color: "#007aff",
    fontWeight: "bold",
    textDecoration: "none",
  },
};

export default SupportPage;
